import { contact } from '../../components/cartoon/links';

// Every policy text lives here so the owner reviews and approves them in one place.
// Drafts written from what the store does today; not legal advice.

// Section `body`: a string is a paragraph, an array of strings is a bullet list.

const PENDING = 'TBD (owner: Diego)';

export const POLICIES_UPDATED_AT = '22 de outubro de 2026';

const seller = {
    tradeName: 'Loop Coffee',
    legalName: PENDING,
    cnpj: PENDING,
    city: contact.city,
};

const privacy = {
    slug: 'privacidade',
    label: 'Privacidade',
    title: 'Política de privacidade',
    intro: 'Como a Loop Coffee trata os seus dados pessoais quando você compra pelo site ou fala com a gente, de acordo com a Lei Geral de Proteção de Dados (Lei 13.709/2018).',
    sections: [
        {
            heading: 'Quem é responsável pelos seus dados',
            body: [
                `${seller.tradeName} (razão social: ${seller.legalName}; CNPJ: ${seller.cnpj}), ${seller.city}.`,
                `Para qualquer assunto sobre os seus dados, inclusive os pedidos de titular abaixo, escreva para ${contact.email}.`,
            ],
        },
        {
            heading: 'Quais dados coletamos',
            body: [
                [
                    'No checkout: e-mail, nome, sobrenome, CPF ou CNPJ, telefone (opcional) e endereço de entrega (CEP, endereço, complemento, cidade e estado).',
                    'Do pedido: produtos, valores, forma de entrega escolhida e situação do pagamento.',
                    'No atendimento: o que você nos envia pelo WhatsApp, e-mail ou Instagram.',
                ],
                'Os dados do cartão são digitados na página de pagamento do Asaas e não passam pela Loop Coffee.',
            ],
        },
        {
            heading: 'Para que usamos',
            body: [
                [
                    'Registrar e cobrar o pedido (execução do contrato de compra).',
                    'Calcular o frete, gerar a etiqueta de envio e entregar o pedido. A transportadora e o Asaas exigem o CPF ou CNPJ de quem compra.',
                    'Enviar e-mails sobre o pedido e o pagamento, e responder ao seu contato.',
                    'Cumprir obrigações legais e fiscais, como a emissão de documentos da venda.',
                ],
                'Não vendemos seus dados e não os usamos para publicidade.',
            ],
        },
        {
            heading: 'Com quem compartilhamos',
            body: [
                'Só com quem precisa deles para o pedido acontecer:',
                [
                    'Asaas: processamento do pagamento (Pix e cartão).',
                    'Melhor Envio, Correios e transportadoras parceiras: cotação do frete, etiqueta e entrega em todo o Brasil.',
                    'Entregador da entrega local em Londrina: nome, telefone e endereço para levar o pedido até você.',
                    'Resend: envio dos e-mails do pedido.',
                    'Provedores de hospedagem e de monitoramento de erros que mantêm o site funcionando.',
                    'Autoridades públicas, quando a lei exigir.',
                ],
            ],
        },
        {
            heading: 'Cookies e armazenamento no navegador',
            body: [
                'O site não usa cookies de rastreamento nem de publicidade. Para o carrinho funcionar, o navegador guarda apenas o identificador do carrinho e do último pedido em andamento; você pode apagá-los limpando os dados do site no seu navegador.',
            ],
        },
        {
            heading: 'Por quanto tempo guardamos',
            body: [
                'Pelo tempo necessário para concluir o pedido, atender trocas e devoluções e cumprir os prazos exigidos pela legislação fiscal e de defesa do consumidor. Depois disso, os dados são apagados ou anonimizados.',
            ],
        },
        {
            heading: 'Seus direitos',
            body: [
                `Você pode pedir a confirmação de que tratamos seus dados, o acesso a eles, a correção de dados incompletos ou errados, a portabilidade, a eliminação dos dados que não precisamos mais guardar por lei e a informação sobre com quem os compartilhamos. Basta escrever para ${contact.email}; respondemos pelo mesmo canal.`,
            ],
        },
        {
            heading: 'Segurança',
            body: [
                'O site usa conexão criptografada (HTTPS), o acesso aos pedidos é restrito à equipe da loja e os pagamentos ficam com o Asaas.',
            ],
        },
    ],
};

const delivery = {
    slug: 'entrega',
    label: 'Entrega e retirada',
    title: 'Entrega e retirada',
    intro: 'As formas de receber o seu café. As opções disponíveis para o seu CEP, com preço e prazo, aparecem no checkout antes de você finalizar o pedido.',
    sections: [
        {
            heading: 'Envio para todo o Brasil',
            body: [
                'Enviamos pelos Correios e por transportadoras parceiras, contratados pelo Melhor Envio. O prazo mostrado no checkout é a estimativa da transportadora, em dias úteis.',
                `Postamos o pedido em até ${PENDING} dias úteis depois da confirmação do pagamento.`,
                'Para acompanhar o envio, peça o código de rastreamento pelo WhatsApp.',
            ],
        },
        {
            heading: 'Entrega local em Londrina',
            body: [
                'Em parte de Londrina entregamos com motoboy, saindo do ponto mais próximo que tem o seu café em estoque. O preço depende da distância e o prazo aparece no checkout.',
                'Quando a entrega local atende o seu CEP, as opções dos Correios não aparecem.',
                'Tenha alguém para receber no endereço informado. Se não houver ninguém, combinamos uma nova tentativa pelo WhatsApp ou pelo telefone do pedido.',
            ],
        },
        {
            heading: 'Retirada em Londrina',
            body: [
                'A retirada é grátis e aparece no checkout com o nome do ponto. Depois que o pagamento for confirmado, combinamos com você pelo WhatsApp o endereço e o horário para retirar.',
            ],
        },
        {
            heading: 'Endereço, atrasos e extravios',
            body: [
                'Confira o endereço antes de finalizar: ele é usado na etiqueta e na entrega. Se o pedido voltar por endereço incorreto ou por ninguém receber, combinamos o reenvio, e o novo frete fica por conta de quem comprou.',
                'Se o pedido atrasar além do prazo informado ou se extraviar, fale com a gente: acionamos a transportadora e reenviamos o pedido ou devolvemos o valor pago.',
            ],
        },
    ],
};

const returns = {
    slug: 'trocas',
    label: 'Trocas e devoluções',
    title: 'Trocas e devoluções',
    intro: 'Seus direitos de desistência e troca, conforme o Código de Defesa do Consumidor.',
    sections: [
        {
            heading: 'Desistência da compra',
            body: [
                'Você pode desistir da compra em até 7 dias corridos depois de receber o pedido, sem precisar justificar (art. 49 do Código de Defesa do Consumidor).',
                'Avise pelo e-mail ou pelo WhatsApp com o número do pedido. Combinamos a devolução do produto, e o custo do envio de volta é nosso. Devolvemos o valor total pago, incluindo o frete.',
            ],
        },
        {
            heading: 'Produto com defeito ou avariado',
            body: [
                'Se o café chegar com a embalagem violada, danificada ou com algum problema, fale com a gente em até 30 dias depois do recebimento, com fotos do produto e da embalagem. Enviamos um novo produto ou devolvemos o valor pago, como você preferir.',
            ],
        },
        {
            heading: 'Como devolvemos o valor',
            body: [
                [
                    'Pix: devolução por Pix para a conta que pagou.',
                    'Cartão de crédito: estorno pelo Asaas na fatura do cartão; o prazo para aparecer depende do banco emissor e pode levar até duas faturas.',
                ],
                'Fazemos a devolução assim que recebermos o produto de volta ou, em caso de avaria, assim que confirmarmos o problema pelas fotos.',
            ],
        },
    ],
};

const shipping = {
    slug: 'frete',
    label: 'Frete',
    title: 'Frete',
    intro: 'Como o valor do frete é calculado e cobrado.',
    sections: [
        {
            heading: 'Como calculamos',
            body: [
                [
                    'Envio para todo o Brasil: cotado pelo Melhor Envio com os Correios e transportadoras parceiras, conforme o CEP de destino e o peso do pedido.',
                    'Entrega local em Londrina: preço por faixa de distância entre o ponto de saída e o seu endereço.',
                    'Retirada em Londrina: grátis.',
                ],
                'O frete aparece no checkout depois que você informa o endereço e entra no total antes de você finalizar o pedido. Ele é pago junto com o pedido, por Pix ou cartão.',
            ],
        },
        {
            heading: 'Frete grátis',
            body: [
                'No momento não oferecemos frete grátis. Se isso mudar, a condição será publicada nesta página e no site.',
            ],
        },
        {
            heading: 'Prazo',
            body: [
                'Cada opção de frete mostra o prazo estimado no checkout. Os detalhes de envio, entrega local e retirada estão na política de entrega e retirada.',
            ],
        },
    ],
};

export const POLICIES = [privacy, delivery, returns, shipping].map((policy) => ({
    ...policy,
    path: `/politicas/${policy.slug}`,
}));
